import {Mapper} from '@s-ui/domain'

import {SellerErrorsFactory} from '../Errors/factory.js'

export default class FromSellerErrorsToContactValidationSellerErrors extends Mapper {
  constructor({config}) {
    super()
  }

  map({errors}) {
    return errors.map(error => {
      switch (error.code) {
        case 'contact-seller.empty-name':
          return SellerErrorsFactory.emptyNameSellerError()
        case 'contact-seller.empty-email':
          return SellerErrorsFactory.emptyEmailSellerError()
        case 'contact-seller.invalid-email':
          return SellerErrorsFactory.invalidEmailSellerError()
        case 'contact-seller.invalid-phone':
          return SellerErrorsFactory.invalidPhoneSellerError()
        default:
          return SellerErrorsFactory.genericSellerError()
      }
    })
  }
}
